(function containerTypeAssociateMetadataControllerDefinition() {
    'use strict';

    angular.module('ContainerType')
        .controller('ContainerTypeAssociateMetadataController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', '$uibModal', '$q', 'errorsExtend', 'adminContainerTypeService', 'adminMetadataService', 'authExtend', 'alerts',
            function containerTypeAssociateMetadataController($scope, config, $state, $translate, $stateParams, $modal, $q, errors, adminContainerTypeService, adminMetadataService, authExtend, alerts) {
                $scope.models = {
                    selected: null,
                    source: null,
                    associated: [],
                    disabled: [],
                    availables: [],
                    nameTemplate: ''
                };

                adminContainerTypeService.getById($stateParams.id, 'Put').then(function (result) {
                    if (!authExtend.isInRole('CONFIG ADMIN APPS') && !authExtend.isInRole('CONTAINERTYPE WRITE') && result.applicationId !== config.appId()) {
                        errors.showError("forbidden");
                        $state.go('container-type-find');
                    }

                    $scope.containerType = result;

                    $scope.models.associated = result.metadata;      
                    $scope.models.disabled = result.disabledMetadata;

                    $scope.models.nameTemplate = $scope.containerType.nameTemplate;
                }, function (error) {
                    errors.showError(error);
                    $state.go('container-type-find');
                }).then(function () {
                    adminMetadataService.getNotInContainerType($stateParams.id).then(function (result) {               
                        $scope.models.availables = result;
                    });
                });

                $scope.moveFromAssociated = function (item, index) {
                    $scope.models.associated.splice(index, 1);
                    if (item.isNew) {
                        $scope.models.availables.splice(item.previousIndex, 0, item);
                    }
                    else {
                        $scope.models.disabled.push(item);
                    }
                };

                $scope.moveFromDisabledRight = function (item, index) {
                    $scope.models.disabled.splice(index, 1);
                    if (item.previousIndex !== undefined) {
                        $scope.models.availables.splice(item.previousIndex, 0, item);
                    }
                    else {
                        $scope.models.availables.push(item);
                    }
                };

                $scope.moveFromDisabledLeft = function (item, index) {
                    $scope.models.disabled.splice(index, 1);
                    $scope.models.associated.push(item);
                    return $scope.postProcess(item, $scope.models.associated.length - 1);
                };

                $scope.moveFromAvailable = function (item, index) {
                    item.isNew = true;
                    item.previousIndex = index;
                    $scope.models.availables.splice(index, 1);
                    $scope.models.associated.push(item);
                    return $scope.postProcess(item, $scope.models.associated.indexOf(item));
                };

                $scope.getIndex = function (item, list) {
                    for (var i = 0; list.length > i; i++) {
                        if (item.metadataId === list[i].metadataId)
                            return i;
                    }

                    return -1;
                };

                $scope.validateAction = function (event, index, item) {
                    var currentSource = $scope.models.source;
                    var currentTarget = event.target.parentElement.attributes['dnd-list'].value;
                    $scope.models.source = null;

                    if (!$scope.containerType.hasAssociatedDocument || item.isNew) {
                        if (currentTarget === 'models.associated') {
                            if (currentSource === 'models.availables') {
                                item.previousIndex = $scope.getIndex(item, $scope.models.availables);
                                item.isNew = true;
                            }
                            return $scope.postProcess(item, index);
                        } else {
                            return item;
                        }
                    }

                    if (currentTarget === 'models.availables') {
                        return false;
                    }

                    if (currentSource === 'models.availables') {
                        item.previousIndex = $scope.getIndex(item, $scope.models.availables);
                        item.isNew = true;
                    }

                    if (currentTarget === 'models.associated') {
                        return $scope.postProcess(item, index);
                    }

                    return item;
                };


                $scope.removeItem = function (source, index) {
                    source.splice(index, 1);
                };

                $scope.setSource = function (event) {
                    $scope.models.source = event.target.parentElement.attributes['dnd-list'].value;
                };

                $scope.cancel = function () {
                    $state.go('container-type-find');
                };

                $scope.save = function (apply) {

                    for (var index = 0; index < $scope.models.associated.length; index++) {
                        $scope.models.associated[index].position = index;
                    }

                    if (!apply) {
                        return adminContainerTypeService.modify($scope.containerType).then(function () {
                            $state.go('container-type-find');
                        },
                            function (error) {
                                errors.showError(error);
                            });
                    }

                    $translate(['TouchContainersConfirm', 'TouchContainersConfirmText', 'Yes', 'No']).then(function (translated) {

                        return alerts.confirm(translated.TouchContainersConfirm, translated.TouchContainersConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                return;
                            }

                            return adminContainerTypeService.modify($scope.containerType).then(function () {

                                return adminContainerTypeService.touchContainers($scope.containerType.id).then(function () {
                                    $state.go('container-type-find');
                                }, function (error) {
                                    errors.showError(error);
                                    $state.go('container-type-find');
                                });

                            },
                                function (error) {
                                    errors.showError(error);
                                });
                        });
                    });
                };

                function setValue(scope, property, value) {
                    if (value) {
                        $q.when(value).then(function (val) {
                            scope[property] = val;
                        });
                    }
                }

                var modalController = function ($scope, $modalInstance, $translate, info) {
                    setValue($scope, 'title', info.name);
                    $scope.item = info;
                    $scope.showAsName = true;
                    if (!$scope.item.asName) {
                        for (var i = 0; i < $scope.item.associated.length; i++) {
                            if ($scope.item.associated[i].asName) {
                                $scope.showAsName = false;
                                break;
                            }
                        }
                    }

                    $scope.setRequired = function () {
                        $scope.item.required = "1";
                    };

                    $scope.unSetAsMetadata = function () {
                        $scope.item.asName = "0";
                    };

                    $scope.ok = function () {
                        $modalInstance.close($scope.item);
                    };

                    $scope.setRequired = function () {
                        $scope.item.required = "1";
                    };

                    $scope.checkRequirityChange = function () {
                        //if($scope.item.isIdentifier == "1") {
                        //    $scope.item.required = "1";
                        //}
                    };

                    $scope.onResultCriteriaChange = function (item) {
                        if (item.resultCriteria === "0") {
                            item.isSortable = "0";
                        }
                    };
                };

                modalController.$inject = ['$scope', '$modalInstance', '$translate', 'info'];
                function openModal(item, associated, countSortableMetadatas) {
                    var modalInstance = $modal.open({
                        templateUrl: '/app/views/container-type/partial-metadata-association.html',
                        controller: modalController,
                        size: 'md',
                        resolve: {
                            info: function () {
                                
                                var response = {
                                    name: item.metadataLabel,
                                    required: item.isRequired,
                                    unique: item.isUnique,
                                    searchCriteria: item.isSearchCriteria,
                                    resultCriteria: item.isResultCriteria,
                                    replicated: item.isReplicated,
                                    isIdentifier: item.isIdentifier,
                                    asName: item.asName,
                                    associated: associated,
                                    isMultivalue: item.isMultivalue,
                                    isSortable: item.isSortable,
                                    mask: item.mask === '' ? item.metadataMask : item.mask,
                                    label: item.label === '' ? item.metadataLabel : item.label,
                                    metadataType: item.metadataType,
                                    metadataLabel: item.metadataLabel,
                                    canSortMetadata: (countSortableMetadatas < config.maxSorteableMetadatas() || item.isSortable),
                                    idObject: item.metadataId,
                                    metadataIsRequired: item.isRequired,
                                    metadataIsUnique: item.isUnique,
                                    metadataValue: item.metadataValue,
                                    metadataOptions: item.optionValues,
                                    maskPlaceHolder: item.metadataMaskPlaceHolder,
                                    metadataAsName: item.asName,
                                    metadataAttributes: item.attributes,
                                    metadataIsMultivalue: item.isMultivalue                                
                                };

                                if (response.showDefaultValue === undefined) {
                                    response.showDefaultValue = !(item.isRequired  && item.id !== null);
                                }

                                return response;
                            }
                        }                      
                    });

                    var result = modalInstance.result;
                    return result;
                }

                $scope.postProcess = function (item, index) {
                    var oldIndex = $scope.getIndex(item, $scope.models.associated);
                    if (oldIndex >= 0 && index > oldIndex) {
                        //le saco una pos, porque cuenta su viejo registro.
                        index--;
                    }
                    var countSortableMetadatas = $scope.containerType.metadata.filter(function (x) { return x.isSortable === true; }).length;
                    openModal(item, $scope.models.associated, countSortableMetadatas).then(function (result) {
                        var currentItem = $scope.models.associated[index];
                        currentItem.isRequired = result.required === true || result.required === '1';
                        currentItem.isUnique = result.unique === true || result.unique === '1';
                        currentItem.isSearchCriteria = result.searchCriteria === true || result.searchCriteria === '1';
                        currentItem.isResultCriteria = result.resultCriteria === true || result.resultCriteria === '1';
                        currentItem.isSortable = result.isSortable === true || result.isSortable === '1';
                        currentItem.isReplicated = result.replicated === true || result.replicated === '1';
                        currentItem.isIdentifier = result.isIdentifier === true || result.isIdentifier === '1';
                        currentItem.asName = result.asName === true || result.asName === '1';
                        currentItem.mask = result.mask;
                        currentItem.label = result.label;
                        currentItem.metadataValue = result.metadataValue;
                        currentItem.defaultOldValue = result.metadataValue;
                        
                        currentItem.containerTypeId = $stateParams.id;
                        if (currentItem.id === 0) {
                            currentItem.id = null;
                        }
                    });

                    return item;
                };
            }
        ]);
})();